import { useNavigate } from 'react-router';
import { AuthApi } from '../../../api';
import { ToastStateHandler } from '../../../api/utils/ToastStateHandler';
import { ICallback } from '../../../commonTypes/hook.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpPostForgotPassword = () => {
    const { t } = useTranslation('newNotifications');
    const authApi: AuthApi = useContainer(AuthApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();

    const exec = (email: string, callback: ICallback) => {
        const { exec, clearCache, abort } = authApi.forgotPassword({
            body: {
                username: email,
            },
            onSuccess: () => {
                toastHandler.push('success', t('auth.forgottenPasswordTitle'), t('auth.forgottenPasswordMessage_Success'));
                clearCache();
                if (callback.onSuccess) callback.onSuccess();
            },
            onError: err => {
                if (err.includes('User is not confirmed')) {
                    toastHandler.push('warn', t('auth.forgottenPasswordTitle'), t('auth.forgottenPasswordMessage_Failed'));
                    callback.onError && callback.onError();
                } else if (err.includes('not found by search')) {
                    toastHandler.push('warn', t('auth.registrationRequiredTitle'), t('auth.registrationRequiredMessage_Failed'));
                    navigate('/sign-up');
                } else toastHandler.push('warn', t('auth.forgottenPasswordTitle'), err);
            },
        });
        exec();
        return abort;
    };

    return {
        exec,
    };
};

export default useHttpPostForgotPassword;
